import React, { useCallback, useContext } from 'react';
import { Button, Card, Steps, message } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import { stepTitles } from './stepTitles';
import useService from '@/lib/hooks/useService';
import ArrangeCarButtonWithModal from '../ArrangeCarButtonWithModal';
import UpdateProcessToOnBoardButtonWithModal from '../UpdateProcessToOnBoardButtonWithModal';
import UpdateProcessArrivalButtonWithModal from '../UpdateProcessToArrivalButtonWithModal';
import { ReservationContext } from '../UpdateProcessButtonWithModal';
import styles from './index.module.scss';
import type { CarServiceReservation } from '@/types/database/carService';
import { UpdateReservationsContext } from '../TodayReservations';

const { Step } = Steps;

const ProcessSteps = () => {
  const {
    key: reservationId,
    householdNumber,
    status,
  } = useContext(ReservationContext);
  const updateData = useContext(UpdateReservationsContext);

  const [, , carService] = useService<CarServiceReservation>({
    collectionName: 'carService',
  });

  const getCurrentProcess = useCallback(() => {
    switch (status) {
      case '已預約':
        return 0;
      case '已安排':
        return 1;
      case '車輛已抵達':
        return 2;
      case '已上車':
        return 3;
      default:
        return 4;
    }
  }, [status]);

  const noticeResident = () => {
    axios('/ezcon/api/emitMsgQuery', {
      method: 'POST',
      headers: { authorization: window.localStorage['feathers-jwt'] },
      data: {
        service: 'message',
        event: 'msg',
        title: '個人通知',
        content: `車輛已抵達社區-${dayjs().format('YYYY/MM/DD HH:mm')}`,
        type: 'success',
        class: 'message',
        duration: 8000,
        redirect: '/ezpro/personalNotice',
        query: {
          householdNumbers: householdNumber,
          firebaseClass: '社區管理',
        },
      },
    })
      .then(async () => {
        await carService.patch(reservationId, { status: '車輛已抵達' });
        message.success('已傳送推播給住戶');
        updateData();
      })
      .catch(() => {
        message.error('傳送推播失敗');
      });
  };

  const getButtonContent = (type: string) => {
    switch (type) {
      case 'arrange':
        return <ArrangeCarButtonWithModal />;

      case 'arrivalCommunity':
        return (
          <Button className={styles.stepButton} onClick={noticeResident}>
            通知住戶
          </Button>
        );

      case 'onBoard':
        return <UpdateProcessToOnBoardButtonWithModal />;

      default:
        return <UpdateProcessArrivalButtonWithModal />;
    }
  };

  return (
    <Steps direction="vertical" size="small" current={getCurrentProcess()}>
      {stepTitles.map((step: { title: string; type: string }, index) => {
        const { title, type } = step;
        return (
          <Step
            key={title}
            title={title}
            description={
              getCurrentProcess() === index ? (
                <Card
                  type="inner"
                  title={<div className={styles.cardTitle}>操作</div>}
                >
                  {getButtonContent(type)}
                </Card>
              ) : null
            }
          />
        );
      })}
    </Steps>
  );
};

export default ProcessSteps;
